<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 md6 sm8>
          <h3 class="text-center">Create New Setting</h3>
          <v-card flat>
            <v-card-text>
              <form @submit.prevent="saveSetting">
                <v-text-field label="Name" v-model="setting.name" required="required"></v-text-field>
                <v-text-field label="Value" v-model="setting.value"></v-text-field>
                <v-text-field label="Type" v-model="setting.type" placeholder="String, Number, Boolean, Text"></v-text-field>
                <v-btn small type="submit" color="primary" class="pull-right">
                  <v-icon left>{{ icons.create }}</v-icon>Save
                </v-btn><br>
              </form>
            </v-card-text>
            <v-card-actions class="py-0">
              <v-spacer></v-spacer>
              <inertia-link href="/settings">All Settings</inertia-link>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'

  export default {
    name: 'CreateSettings',
    layout,
    props: [],
    components: {},
    metaInfo () {
      return {
        title: 'Create New Setting',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        setting: this.$inertia.form({
          name: '',
          value: '',
          type: '',
        })
      }
    },
    methods: {
      saveSetting () {
        this.setting.post('/settings')
      },
    },
  }
</script>

<style>
   /**/
</style>
